var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReservedShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23,
    viewBox: "0 0 17 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.56818 23C1.15 23 0.784091 22.8432 0.470454 22.5295C0.156818 22.2159 0 21.85 0 21.4318V8.12841C0 7.71023 0.156818 7.34432 0.470454 7.03068C0.784091 6.71704 1.15 6.56023 1.56818 6.56023H5.98523V8.12841H1.56818V21.4318H15.1591V8.12841H10.6898V6.56023H15.1591C15.5773 6.56023 15.9432 6.71704 16.2568 7.03068C16.5705 7.34432 16.7273 7.71023 16.7273 8.12841V21.4318C16.7273 21.85 16.5705 22.2159 16.2568 22.5295C15.9432 22.8432 15.5773 23 15.1591 23H1.56818ZM7.55341 14.9761V3.03182L5.25341 5.33182L4.12955 4.20795L8.3375 0L12.5455 4.20795L11.4216 5.33182L9.12159 3.03182V14.9761H7.55341Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservedShareIcon);
export default __webpack_public_path__ + "static/media/reserved-share-icon.eb8cc9831848eb6523fcc0c2ce0099af.svg";
export { ForwardRef as ReactComponent };